import { getUserTimezone } from '@app/shared/utils/date.util';

export function formatTime(iso: string | null): string {
  if (!iso) return '';

  return new Date(iso).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
}

export function formatDateSafe(dateStr: string): string {
  const d = new Date(dateStr);

  if (isNaN(d.getTime())) return '—';

  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

export function formatYmdToPretty(ymd: string): string {
  const p = ymd.split('-');
  if (p.length < 3) {
    return ymd;
  }
  const y = +p[0];
  const m = +p[1] - 1;
  const d = +p[2];
  return new Date(y, m, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function stripDate(date: Date): Date {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
}

export function getCashReconciliationToday(): Date {
  const timeZone = getUserTimezone();
  if (!timeZone) {
    return stripDate(new Date());
  }

  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date()).reduce<Record<string, string>>((acc, part) => {
      if (part.type !== 'literal') {
        acc[part.type] = part.value;
      }
      return acc;
    }, {});
    return new Date(Number(parts['year']), Number(parts['month']) - 1, Number(parts['day']));
  } catch {
    return stripDate(new Date());
  }
}

export function disableFutureDates(date: Date): boolean {
  return stripDate(date).getTime() >
         getCashReconciliationToday().getTime();
}